module.exports = __webpack_public_path__ + "img/marlux_certified.0b772ac0.png";